/**
* Copyright Aquera Inc 2023
*
* This source code is licensed under the BSD-3-Clause license found in the
* LICENSE file in the root directory of this source tree.
*/

import {css} from 'lit-element';

/**
 * Tag_2 CSS
 */
export const styles = css`

  :host {
    display: inline-block;
  }

  .tag {
    display: flex;
    align-items: center;
    border: solid 1px;
    line-height: 1;
    white-space: nowrap;
    user-select: none;
  }

  .tag__remove::part(base) {
    color: inherit;
    padding: 0;
  }

  /*
   * Variant modifiers
   */

  .tag--primary {
    background-color: hsl(204 100% 97.1%);
    border-color: hsl(200.6 94.4% 86.1%);
    color: hsl(201 90% 27.5%);
  }

  .tag--primary:active > nile-icon-button {
    color: hsl(200.4 98% 39.4%);
  }

  .tag--success {
    background-color: hsl(138.5 76.5% 96.7%);
    border-color: hsl(141 78.9% 85.1%);
    color: hsl(142.8 64.2% 24.1%);
  }

  .tag--success:active > nile-icon-button {
    color: hsl(142.1 76.2% 36.3%);
  }

  .tag--neutral {
    background-color: hsl(0 0% 97.5%);
    border-color: hsl(240 5.9% 90%);
    color: hsl(240 3.7% 15.9%);
  }

  .tag--neutral:active > nile-icon-button {
    color: hsl(240 5.2% 33.9%);
  }

  .tag--warning {
    background-color: hsl(48 100% 96.1%);
    border-color: hsl(48 96.6% 76.7%);
    color: hsl(26 90.5% 37.1%);
  }

  .tag--warning:active > nile-icon-button {
    color: hsl(32.1 94.6% 43.7%);
  }

  .tag--danger {
    background-color: hsl(0 85.7% 97.3%);
    border-color: hsl(0 96.3% 89.4%);
    color: hsl(0 70% 35.3%);
  }

  .tag--danger:active > nile-icon-button {
    color: hsl(0 72.2% 50.6%);
  }

  /*
   * Size modifiers
   */

  .tag--small {
    font-size: 0.75rem;
    height: calc(1.875rem * 0.8);
    line-height: calc(1.875rem - 1px * 2);
    border-radius: 0.25rem;
    padding: 0 0.5rem;
  }

  .tag--medium {
    font-size: 0.875rem;
    height: calc(2.5rem * 0.8);
    line-height: calc( 2.5rem - 1px * 2);
    border-radius: 0.25rem;
    padding: 0 0.75rem;
  }

  .tag--large {
    font-size: 1rem;
    height: calc(3.125rem * 0.8);
    line-height: calc(3.125rem - 1px * 2);
    border-radius: 0.25rem;
    padding: 0 1rem;
  }

  .tag__remove {
    margin-inline-start: 0.5rem;
  }

  /*
   * Pill modifier
   */

  .tag--pill {
    border-radius: 9999px;
  }
`;

export default [styles];
